<div class="loading-container">
    <img src="assets/img/loading.gif" width="100" height="100" />
</div>

<!-- <div class="progress-spinner" *ngIf="true">
    <p-progressSpinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" aria-label="Loading"></p-progressSpinner>
</div> -->